import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import { routes } from './routes'   // the syntax '{ xxx }' is due to the declaration of "const" (i.e. 'export const xxx') in the imported source.

Vue.prototype.$http = axios

Vue.use(VueRouter)

const router = new VueRouter({
  routes: routes
})

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js